import { ActionStatus, FACTION_NAMES, Room } from '../../../Constants';
import {
    angryDocks,
    clockedInTempStaff,
    clockOutableStaff, ghostCount, ghostedDocks,
} from '../../Game/GamePlayerInfo';


function doIhaveFate(gamePlayerController, aiPackage) {
    const currentFate = gamePlayerController.gamePlayerData.current_fate;
    const result = currentFate > 0;
    const question = 'What about Fate?'
    let reason = 'There is no Fate but what we make'
    if (result) {
        reason = `I have Fate (${currentFate}), Now I must Act.`;
        aiPackage.complete = false;
    } else {
        aiPackage.addToMessage('There is no Fate but what we make');
        aiPackage.complete = true;
        // This is the Ghost action — close it out with ghostJuice, not
        // lodgingJuice (copy-paste from AILodging). Firing the wrong
        // juicer here sent a mismatched package into the Ghost flow.
        if (aiPackage.execute) gamePlayerController.gamePlayerApi.ghostJuice([]);
    }
    aiPackage.addProvenance(question, result, reason);
    return result;
}

function shouldIJuiceGhosting(gamePlayerController, aiPackage) {
    // attack or build matters....
    // I want 2, 3, 4, 5, 6, 7, 8;
    let available = clockOutableStaff(gamePlayerController.gamePlayerData);
    let result = available.length > 0
    let question = 'Do I have available staff for Clock-Out?'
    let reason = 'There are none available.'
    if (result) {
        reason = `There are ${available.length} available.`;
    }
    aiPackage.addProvenance(question, result, reason);
    if (!result) return false;

    let want = 2;
    const current = clockedInTempStaff(gamePlayerController.gamePlayerData).length;
    result = current > want
    question = 'Clock-Out Available Staff to Juice?'
    reason = `I want ${want} and I have ${current}.`;
    aiPackage.addProvenance(question, result, reason);
    return result;
}


function shouldIAttackWithGhosts(gamePlayerController, aiPackage) {
    // todo: glean condition from config
    const question = 'Should I Attack?'
    const reason = `As to not waste an action.`;
    aiPackage.addProvenance(question, true, reason);
    return true;
}


function shouldIRemoveGhosts(gamePlayerController, aiPackage) {
    // todo: glean condition from config
    let question = `Are there Angry Ghosts? `;
    let answer = false;
    let reason = 'Angry Ghosts cost Snohe every round.'
    const angry = angryDocks(gamePlayerController.gamePlayerData);
    if (angry.length > 0) {
        answer = true;
    }
    aiPackage.addProvenance(question, answer, reason);
    if (!answer) {
        question = `Are there Any Ghosts? `;
        answer = false;
        reason = 'Clean docks are superior to Ghosted ones.'
        let docks = ghostedDocks(gamePlayerController.gamePlayerData);
        if (docks.length > 0) {
            answer = true;
        }
        aiPackage.addProvenance(question, answer, reason);
    }
    return answer;
}

function setJuice(gamePlayerController, aiPackage) {
    let clockedOutStaff = [];
    const staffMember = clockOutableStaff(gamePlayerController.gamePlayerData).pop();
    clockedOutStaff.push(staffMember);
    aiPackage.clockedOutStaff = clockedOutStaff
    aiPackage.addToMessage(`Clock Out Staff #${staffMember}`);
}

function attackTarget(gamePlayerController, aiPackage) {
    let message = '';
    let target = null;
    let orderedPlayers = [ ...gamePlayerController.gameData.gameplayer_set ].filter(
        player => player.id !== gamePlayerController.gamePlayerData.id);
    orderedPlayers.sort((a, b) => a.current_score - b.current_score);
    while (orderedPlayers.length > 0) {
        target = orderedPlayers.pop();
        if (ghostCount(target) < 8) {
            message = `Target -> ${target.name}-${target.seat}`;
            aiPackage.addToMessage(message);
            aiPackage.complete = true;
            const question = 'Who has the highest score and is not full?'
            const answer = `${target.name}-${target.seat}`;
            aiPackage.addProvenance(question, answer, 'Seek the strongest.');
        }
    }

    if (!target) {
        aiPackage.addToMessage('No suitable target, Skip');
    }

    if (aiPackage.execute && target) {
        gamePlayerController.gamePlayerApi.ghostFullAction(
            aiPackage.clockedOutStaff,
            target.id,
            null
        )
    } else if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}


function aiRemoveGhost(gamePlayerController, aiPackage) {
    let question = `Are there Angry Ghosts? `;
    let answer = false;
    let reason = 'Start with Angry Ghosts first.'
    let dock = null;
    const angry = angryDocks(gamePlayerController.gamePlayerData);
    if (angry.length > 0) {
        dock = angry.pop();
        answer = true;
        aiPackage.addToMessage('Remove Angry Ghost');
    }
    aiPackage.addProvenance(question, answer, reason);

    if (!answer) {
        question = `Are there Any Ghosts? `;
        answer = false;
        reason = 'Start with Dock 0 and Clean.'
        let docks = ghostedDocks(gamePlayerController.gamePlayerData);
        if (docks.length > 0) {
            dock = docks.pop();
            answer = true;
            aiPackage.addToMessage(`Remove Satisfied Ghost from Dock ${dock}`);
        }
        aiPackage.addProvenance(question, answer, reason);
    }

    aiPackage.complete = true;
    aiPackage.success = true;
    if (dock !== null && aiPackage.execute) {
        gamePlayerController.gamePlayerApi.ghostFullAction(
            aiPackage.clockedOutStaff,
            gamePlayerController.gamePlayerData.id,
            dock,
        )
    } else if (dock == null && aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}


function pickGhostOpponent(gamePlayerController, aiPackage) {
    // Same shape as attackTarget's selection block — highest-score
    // opponent below the ghost-cap — but returns the target object
    // instead of firing a spend. Used by both the pre-roll INIT
    // target commit and the post-roll WAIT_FOR_JUICE spend.
    let orderedPlayers = [...gamePlayerController.gameData.gameplayer_set]
        .filter(player => player.id !== gamePlayerController.gamePlayerData.id);
    orderedPlayers.sort((a, b) => a.current_score - b.current_score);
    while (orderedPlayers.length > 0) {
        const candidate = orderedPlayers.pop();
        if (ghostCount(candidate) < 8) {
            aiPackage.addProvenance(
                'Who has the highest score and is not full?',
                `${candidate.name}-${candidate.seat}`,
                'Seek the strongest.');
            return candidate;
        }
    }
    return null;
}


function aiGhostCommitTarget(gamePlayerController, aiPackage) {
    // Manual §7.2.6 pre-roll target commit. current_fate is zero at
    // INIT — we cannot peek at it. Decision rule: if any ghosts on
    // own docks (would cleanse post-roll), target = self; else
    // target = opponent (via attack selection); fall back to self if
    // no viable opponent.
    let target_id = null;
    const my_id = gamePlayerController.gamePlayerData.id;
    const existingTarget =
        gamePlayerController.gamePlayerData.current_action_target;
    if (existingTarget !== null && existingTarget !== undefined) {
        // Target already committed. A duplicate frame re-firing the INIT
        // handler before the commit's state advance propagated would echo
        // a second ghostCommitTarget that lands as "Turn Click Handler Too
        // Far" once the action has moved on. Refuse to re-send.
        aiPackage.addToMessage(
            'Ghost target already committed; skipping duplicate.');
        aiPackage.complete = true;
        aiPackage.success = true;
        return aiPackage;
    }
    // CC_LODGING_COMMIT_SINGLE_DISPATCH: identical re-fire to the Lodging
    // twin (ghost_action.commit_target is a verbatim mirror of
    // lodging_action.commit_target). The server-confirmed guard above only
    // catches a re-fire after the commit round-trips; the own-seat auto
    // driver re-runs this handler on the SAME patch (eager doTheNextThing
    // then SpeedController.concur) before current_action_target advances,
    // and the second ghostCommitTarget lands at WAIT_FOR_JUICE. Fence the
    // emit on the patch's action-chain head (last_action_uuid rotates once
    // per inbound message): one commit per patch, reset automatically by
    // the next patch's fresh head.
    const actionUuid = gamePlayerController.gamePlayerData.last_action_uuid;
    if (actionUuid !== null && actionUuid !== undefined
            && gamePlayerController._ghostCommitUuid === actionUuid) {
        aiPackage.addToMessage(
            'Ghost target commit already emitted this patch; '
            + 'skipping duplicate.');
        aiPackage.complete = true;
        aiPackage.success = true;
        return aiPackage;
    }
    if (shouldIRemoveGhosts(gamePlayerController, aiPackage)) {
        target_id = my_id;
        aiPackage.addToMessage('Pre-roll Target -> Self (cleanse ghosts)');
    } else {
        const opponent = pickGhostOpponent(
            gamePlayerController, aiPackage);
        if (opponent) {
            target_id = opponent.id;
            aiPackage.addToMessage(
                `Pre-roll Target -> ${opponent.name}-${opponent.seat}`);
        } else {
            target_id = my_id;
            aiPackage.addToMessage(
                'Pre-roll Target -> Self (no opponent available)');
        }
    }
    aiPackage.complete = true;
    aiPackage.success = true;
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.ghostCommitTarget(target_id);
        // CC_LODGING_COMMIT_SINGLE_DISPATCH: stamp the patch head so the
        // concur re-fire on this same patch is fenced above. Only stamp a
        // real head — a null/undefined uuid can't fence and must never
        // strand a later commit.
        if (actionUuid !== null && actionUuid !== undefined) {
            gamePlayerController._ghostCommitUuid = actionUuid;
        }
    }
    return aiPackage;
}


function attackSpendOnCommittedGhostTarget(gamePlayerController, aiPackage) {
    // Target was already committed pre-roll; we just spend staff
    // here. Send a Juice click with sold_robots; backend reads target
    // off current_action_target and routes to apply_attack.
    aiPackage.addToMessage('Spend ghosts on committed opponent target');
    aiPackage.complete = true;
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.ghostJuice(
            aiPackage.clockedOutStaff || []);
    }
}


function aiGhostActionWaitForJuice(gamePlayerController, aiPackage) {
    // Target is already persisted on current_action_target (committed
    // at INIT). This phase makes the juice (clock-out) decision and
    // dispatches spend against the committed target — no
    // target-picking here.

    doIhaveFate(gamePlayerController, aiPackage);

    if (!aiPackage.complete && shouldIJuiceGhosting(gamePlayerController, aiPackage)) {
        setJuice(gamePlayerController, aiPackage);
    }

    const target_id = gamePlayerController.gamePlayerData.current_action_target;
    const my_id = gamePlayerController.gamePlayerData.id;
    if (target_id === my_id) {
        if (!aiPackage.complete && shouldIRemoveGhosts(
                gamePlayerController, aiPackage)) {
            aiRemoveGhost(gamePlayerController, aiPackage);
        }
    } else if (target_id !== null && target_id !== undefined) {
        attackSpendOnCommittedGhostTarget(gamePlayerController, aiPackage);
    } else {
        // Defensive: no target committed. Fall back to legacy in-step
        // decision (should not occur after CC_FATE_ORDER_FRONTEND).
        if (!aiPackage.complete && shouldIRemoveGhosts(
                gamePlayerController, aiPackage)) {
            aiRemoveGhost(gamePlayerController, aiPackage);
        }
        if (!aiPackage.complete && shouldIAttackWithGhosts(
                gamePlayerController, aiPackage)) {
            attackTarget(gamePlayerController, aiPackage);
        }
    }

    aiPackage.success = true;
    return aiPackage;
}


export default function artificialGhostAction(gamePlayerController, aiPackage) {
    switch (gamePlayerController.gamePlayerData.action_status) {
    case ActionStatus.INIT_ID:
        aiGhostCommitTarget(gamePlayerController, aiPackage);
        return aiPackage;
    case ActionStatus.WAIT_FOR_TARGET_ID:
        aiGhostCommitTarget(gamePlayerController, aiPackage);
        return aiPackage;
    case ActionStatus.WAIT_ID:
        aiPackage.addToMessage('Ghost Confirm');
        gamePlayerController.confirmGhostAction();
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.FATE_MINIGAME_ID:
        aiPackage.addToMessage('Ghost Fate Choice');
        gamePlayerController.ghostFateMinigameChoice();
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.FATE_MINIGAME_DONE_ID:
        aiPackage.addToMessage('Ghost Fate Response');
        gamePlayerController.ghostFateMinigameDone();
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.WAIT_FOR_JUICE:
        aiGhostActionWaitForJuice(gamePlayerController, aiPackage);
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.JUICE_ID:
        aiPackage.addToMessage('Ghost Status Juice not supported');
        return aiPackage;
    case ActionStatus.REMOVE_ID:
        aiRemoveGhost(gamePlayerController, aiPackage);
        return aiPackage;
    case ActionStatus.ATTACKING_ID:
        aiPackage.addToMessage('Ghost Attack Underway');
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.DONE_ID:
        aiPackage.addToMessage('Ghost Done Confirmation');
        aiPackage.success = true;
        return aiPackage;
    default:
        console.error('Ghost Too Far.', gamePlayerController.gamePlayerData.action_status);
        break;
    }
}
